<template>
  <v-card>
    <v-form @submit.prevent="submitEditDriver()" ref="editDriverForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="`${driver.name} (${driver.contractor.name})`"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedDriver.name"
              label="* Name"
              autofocus
              :loading="loading"
              :rules="nameRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedDriver.contactEmail"
              label="Contact Email"
              :loading="loading"
              :rules="contactEmailRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="editedDriver.contactPhone"
              label="Contact Phone"
              :loading="loading"
              :rules="contactPhoneRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch
              :hint="!editedDriver.contractor.active ? 'This Driver is set to Inactive by its related Sub-Contractor' : null"
              persistent-hint
              label="Active"
              :color="$store.state.global.pages.driver.color"
              v-model="editedDriver.active"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm6 v-if="$store.state.user.userAuthClass.name === 'Administrator'">
            <v-switch label="Request" v-model="editedDriver.request" :disabled="!userAuthClass"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
    <inductions-panel
      :projects="projects"
      :currentProjects="currentProjects"
      :currentInductions="currentInductions"
      :discarding="discarding"
      @selectedChanged="onSelectedChanged"
      @selectedInductionsChanged="onSelectedInductionsChanged"
      @discard="discarding = false"
      @triggerInductionChange="triggerInductionChange"
      isDriver
      v-if="initData"
    ></inductions-panel>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DriverService from '@/services/requests/driverService'
import DriverProjectService from '@/services/requests/driverProjectService'

// MIXINS
import DriverValidation from '@/services/validation/driverValidation'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import InductionsPanel from '@/components/ui/inductionsPanel'

export default {
  mixins: [DriverValidation],
  components: {
    DialogHeader,
    InductionsPanel,
  },
  data() {
    return {
      editedDriver: Object.assign({}, this.driver),
      loading: false,
      selectedProjects: [],
      currentProjects: [],
      allProjects: [],
      projectPanel: false,
      projectColor: this.$store.state.global.pages.project.color,
      selectAllProjects: false,
      selectedInductions: {},
      currentInductions: {},
      inductionsChanged: false,
      discarding: false,
      initData: false,
      test1: [],
      test2: [],
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    snackEmit(options) {
      this.$emit('snack', options)
    },
    discard() {
      this.editedDriver = Object.assign({}, this.driver)
      this.selectedProjects = [...this.currentProjects]
      this.selectedInductions = Object.assign({}, this.currentInductions)
      this.triggerInductionChange()
      this.close()
    },
    submitEditDriver() {
      if (!this.$refs.editDriverForm.validate()) {
        return
      }
      this.save()
    },
    getDriverProjectsByDriver() {
      DriverProjectService.getDriverProjectsByDriver(this.driver.id)
        .then((result) => {
          for (const project of this.projects) {
            const selectedProject =
              result.data.result[
                this.searchByAttr(result.data.result, 'projectId', project.id)
              ]
            if (selectedProject) {
              if (selectedProject.cardNo)
                this.currentInductions[project.id] = selectedProject.cardNo
            }
            this.allProjects.push(project.id)
            this.selectedInductions = Object.assign({}, this.currentInductions)
          }
          this.setCurrentProjects(result.data.result)
          this.initData = true
        })
        .catch((err) => {
          this.snackError()
          console.log(err)
        })
    },
    setCurrentProjects(data) {
      this.selectedProjects = []
      this.currentProjects = []
      for (const record of data) {
        this.selectedProjects.push(record.projectId)
        this.currentProjects.push(record.projectId)
      }
    },
    save() {
      const inductions = []
      for (const projectId of this.selectedProjects) {
        inductions.push({
          projectId,
          number: this.selectedInductions[projectId],
        })
      }
      const postedDriver = { ...this.editedDriver, inductions }
      this.loading = true
      DriverService.updateDriver(postedDriver)
        .then((result) => {
          this.loading = false
          this.$store.commit('drivers/updateArrayStateByValue', {
            prop: 'drivers',
            value: this.driver,
            editedValue: result.data.result.driver,
          })
          this.editedDriver = Object.assign({}, result.data.result.driver)
          this.setCurrentProjects(result.data.result.driverProjects)
          this.currentInductions = Object.assign({}, this.selectedInductions)
          this.triggerInductionChange()
          this.snack({ color: 'green', text: 'Driver was edited' })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
    onSelectedChanged(val) {
      this.selectedProjects = val
    },
    onSelectedInductionsChanged(val) {
      console.log('SELECTED INDUCTIONS CHANGED')
      this.selectedInductions = val
    },
    triggerInductionChange() {
      console.log('INDUCTION CHANGED')
      !this._.isEqual(this.selectedInductions, this.currentInductions)
        ? (this.inductionsChanged = true)
        : (this.inductionsChanged = false)
    },
  },
  computed: {
    projects: Store.getSet({ store: 'projects', prop: 'projects' }),
    different() {
      if (
        !this._.isEqual(this.driver, this.editedDriver) ||
        !this._.isEqual(
          this.selectedProjects.sort().join(','),
          this.currentProjects.sort().join(',')
        ) ||
        this.inductionsChanged
      ) {
        return true
      } else {
        return false
      }
    },
  },
  async mounted() {
    await this.getDriverProjectsByDriver()
  },
  props: {
    driver: Object,
  },
  watch: {
    selectAllProjects(val) {
      val
        ? (this.selectedProjects = this.allProjects)
        : (this.selectedProjects = [])
    },
  },
}
</script>

<style>
</style>
